import React from "react";

const Title = ({ text1, text2 }) => {
  return (
    <div
      className="text-center pt-4 mb-2"
      style={{ backgroundColor: "#f8f8f8", paddingBottom: "0.5rem" }}
    >
      <label className="d-block pl-1 pr-1"> {text1} </label>
      <label className="d-block pl-1 pr-1">{text2} </label>
    </div>
  );
};

export default Title;
